import { MY_LIFESTYLE } from '../constants';
import { LIFESTYLE } from '../constants/progressCategories';

const myLifestyleStress = {
  name: 'stress',
  category: MY_LIFESTYLE,
  progressCategory: LIFESTYLE,
  route: `/consultation/haircare/${MY_LIFESTYLE}/stress`,
  title: 'How often are you stressed out?',
  subtitle: 'This could be big or small—we’re interested in the frequency, not the intensity.',
  tip: {
    title: 'Why we ask:',
    content:
      'Emotional stress can weaken hair, so be honest about your feelings. We’ll create products that give your hair the strength and resilience it needs on good days and bad.',
  },
  options: [
    { value: 'never', label: 'Rarely' },
    { value: 'little', label: 'Maybe once a week' },
    { value: 'moderately', label: 'Multiple times a week' },
    { value: 'lot', label: 'Every day' },
  ],
  isEnabled: ({ showSkincare }) => !showSkincare,
  shouldBeIncluded: () => true,
  getInitialValue: answers => answers.profile_stress_level,
  getAnswers: ({ selected }) => ({ profile_stress_level: selected }),
};

export default myLifestyleStress;
